module.exports = __webpack_public_path__ + "img/txt_info3.36e22c18.png";